import { market as marketEnum } from 'types/timetableServices';

export const localeToLanguage = (locale) => {
  switch (locale) {
    case 'fr-FR':
      return 'FR';
    case 'nl-NL':
      return 'NL';
    case 'de-DE':
      return 'DE';
    case 'en-GB':
    default:
      return 'EN';
  }
};

export const localeToMarket = (locale) => {
  switch (locale) {
    case 'fr-FR':
      return 'fr-fr';
    case 'nl-NL':
      return 'nl-nl';
    case 'en-GB':
    default:
      return 'uk-en';
  }
};

export const localeToTimetableServiceMarketEnum = (locale) => {
  switch (locale) {
    case 'be-FR':
      return marketEnum.BE_FR;
    case 'be-EN':
      return marketEnum.BE_EN;
    case 'be-NL':
      return marketEnum.BE_NL;
    case 'de-DE':
      return marketEnum.DE_DE;
    case 'fr-FR':
      return marketEnum.FR_FR;
    case 'nl-NL':
      return marketEnum.NL_NL;
    case 'en-US':
      return marketEnum.US_EN;
    case 'en-GB':
    default:
      return marketEnum.UK_EN;
  }
};
